import { render, staticRenderFns } from "./ActiveItem.vue?vue&type=template&id=700e8a3e&scoped=true"
import script from "./ActiveItem.vue?vue&type=script&lang=js"
export * from "./ActiveItem.vue?vue&type=script&lang=js"
import style0 from "./ActiveItem.vue?vue&type=style&index=0&id=700e8a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700e8a3e",
  null
  
)

export default component.exports